export const get_security_amount = `query get_security_amount($account: String!, $security: String!){
    get_security_amount(account: $account, security: $security){
        balance
        investable
        daytrade_limit
    }
}`;
